/**
 * ChatScroller - Utility for scrolling chat history to bottom
 */
export class ChatScroller {
    constructor(selector = '.chat_history') {
        this.selector = selector;
    }

    /**
     * Scroll all chat histories to bottom
     */
    scrollToBottom() {
        const chatHistories = document.querySelectorAll(this.selector);
        
        chatHistories.forEach(history => {
            history.scrollTop = history.scrollHeight;
        });
    }

    /**
     * Initialize on DOM ready
     */
    static init(selector = '.chat_history') {
        const scroller = new ChatScroller(selector);
        scroller.scrollToBottom();
        return scroller;
    }
}

